const calculateAge = (year: string): string => {
  if (!year) return 'нет года';

  const result: number = new Date().getFullYear() - Number(year);

  if (result > 120) return 'некорректный год';
  return `${result}`;
};

export default calculateAge;
